import React from 'react';
import PropTypes from 'prop-types';
import '../SearchFilters.css';

const ChannelGroupsDropdown = ({
  groups,
  selected,
  label,
  onSelect,
  ...props
}) => {
  return (
    <div className='flex-columns flex-1'>
      <span className='native-select-label'>{label}</span>
      <select
        className='native-select-styled'
        value={selected}
        onChange={onSelect}
      >
        <option value={-1}>All</option>
        { Object.keys(groups).map(key => {
          const group = groups[key];

          return (
            <optgroup label={key} key={key}>
              { group.length > 0
                ? group
                : <option disabled>-- None --</option>
              }
            </optgroup>
          );
        })}
      </select>
    </div>
  );
};

ChannelGroupsDropdown.propTypes = {
  groups: PropTypes.object,
  selected: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func
};

export default ChannelGroupsDropdown;
